import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgPhoneIconSecondary from './svgs/PhoneIconSecondary.js';
import SvgPhoneIcon from './svgs/PhoneIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var phoneIcon = (props => useIcon(SvgPhoneIcon, SvgPhoneIconSecondary, props));

export { phoneIcon as default };
